import { useSelector } from 'react-redux';

import { RootState } from '@/store/store';

import StoreSetting, { StoreSettingValue } from '@/models/store-setting/StoreSetting';


interface UseStoreSettingResult {
	setting: StoreSetting | null;
	value: StoreSettingValue;
	loading: boolean;
}


const useStoreSetting = (group: string, key: string): UseStoreSettingResult => {

	const qualifiedKey = `${group}.${key}`;
	const setting = useSelector((state: RootState) => {
		const map = state.store?.settings || {};
		return (map[qualifiedKey] as StoreSetting | undefined) || null;
	});
	const loading = useSelector((state: RootState) => Boolean(state.store?.settingsPending));

	const value: StoreSettingValue = setting
		? (setting.value !== null && setting.value !== undefined ? setting.value : setting.defaultValue)
		: null;

	return { setting, value, loading };
};


export default useStoreSetting;
